//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RepertoryOne from './components/repertoryOne.vue'
import RepertoryTwo from './components/repertoryTwo.vue'
import RepertoryThree from './components/repertoryThree.vue'
import RepertoryFour from './components/repertoryFour.vue'
import RepertoryFive from './components/repertoryFive.vue'
export default {
  components:{
    RepertoryOne,RepertoryTwo,RepertoryThree,
    RepertoryFour,RepertoryFive
  },
  data() {
    return {
      com:'RepertoryOne',
      shopMsg:{},
    }
  },
  mounted(){
    this.info()
  },
  methods:{
    info(){
      this.shopMsg = []
      this.$axios.get('/mtea/stock/shopInfo/get', {params:{sysShopId:this.$route.query.shopId}}).then(res => {
        this.shopMsg = res
      }).catch((err)=>{
        console.log(err)
      })
    },
    comisFun(comIs){
      if(this.com !== comIs){
        this.$refs[this.com].style.backgroundColor = '#d3d1d1'
        this.$refs[comIs].style.backgroundColor = '#f1f1f1'
        this.com = comIs
      }
    },
    alterMsg(){
      this.$router.push({name:'alterMsg',query:{shopId:this.$route.query.shopId}})
    },
    // returnFun(){
    //   window.sessionStorage.setItem('tab','3')
    //   // this.$router.push({path: '/operate/cloud'})
    //   this.$router.go(-1)
    // }
  }
}
